/**Adds an object to list for viewing All and removing query from url */
export const addAllToList = <T extends { key?: string | number | null }>(
  list: T[] | null | undefined,
  name = 'All',
  addNone?: boolean,
) => {
  if (!list) {
    return [];
  } else if (!list.some((item) => item.key === -1)) {
    const newList = [{ key: -1, name, abbreviation: `${name}` }, ...list];

    if (addNone && !newList.some((item) => item.key === -2)) {
      return [{ key: -2, name: 'None', abbreviation: 'None' }, ...newList];
    }

    return newList;
  }

  return list;
};
